import React from 'react'

import { Trans, useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router-dom'

import LinkButton from '@components/shared/LinkButton'
import nfLogoBlack from '@images/icons/noteflight-logo-black.svg'
import nfLogo from '@images/icons/noteflight-logo.svg'
import '@styles/main.css'

const UnexpectedErrorPage: React.FC = () => {
  const error = useRouteError()
  console.error(error)
  const { t } = useTranslation()
  return (
    <div className="inset-0 flex flex-col h-screen bg-gray-light dark:bg-black-bg items-center px-2 pt-10">
      <img
        src={nfLogo}
        role="image"
        alt="Noteflight"
        className="w-full max-w-[300px] h-auto mb-6 dark:block hidden"
      />
      <img
        src={nfLogoBlack}
        role="image"
        alt="Noteflight"
        className="w-full max-w-[300px] h-auto mb-6 dark:hidden"
      />
      <h1 className="w-full text-center text-h3 mb-2">{t('errorUnexpected.title')}</h1>
      <p className="text-md text-gray-text mb-8 text-center">
        <Trans i18nKey="errorUnexpected.subtitle">
          Please try again. If the issue continues email
          <a href="mailto:support@noteflight.com" className="orange-link">
            support@noteflight.com
          </a>
          and include the URL of this page.
        </Trans>
      </p>
      <LinkButton variant="primary" href="/" title={t('error404.action')} external>
        {t('error404.action')}
      </LinkButton>
    </div>
  )
}

export default UnexpectedErrorPage
